export const baseEnv = {
  production: false,
  name: 'base',

  backendUrl: 'http://localhost:3000',
  UIsUrl: 'http://localhost:4200',

  domain: 'localhost',

  plannerPath: '/planner/',
  adminPath: '/admin/',
  reportingPath: '/reporting/',
  dashboardPath: '/dashboard/',
  respondentPath: '/respondent/',

  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:f2144df2-63fb-4350-a2be-9f6f633ea98b',
  userPoolId: 'eu-west-1_RTwnRteKK',
  clientId: '3feo2lks6thivqvvprfm3lsool',

  // amazon endpoints
  stsEndpoint: 'sts.eu-west-1.amazonaws.com',
  cognito_idp_endpoint: '',
  cognito_identity_endpoint: '',

  // Device used to open the respondent
  deviceMobile: false,

  // LCP api
  lcpApiUrl: 'http://localhost:3001/v1',

  APP_AWS_COGNITO_CLIENT_ID: "2innj2bq1ha9hiavmmmmdf7eda",
  APP_AWS_COGNITO_APP_WEB_DOMAIN: "zoom.auth.eu-west-1.amazoncognito.com",
  APP_AWS_COGNITO_USER_POOL_ID: "eu-west-1_GaEDCImgx"
};



// WEBPACK FOOTER //
// ./src/environments/environment.base.ts